<!--
 * @Author: Jimmy 1554423971@qq.com
 * @Date: 2025-09-06 15:47:04
 * @LastEditors: Jimmy 1554423971@qq.com
 * @LastEditTime: 2025-09-06 15:59:42
 * @FilePath: \electric-dispatch-web\src\views\settlement-model\components\ConfirmEdit.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-dialog
    title="修改确认"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div style="text-align: center; padding: 20px 0">
      <i
        class="el-icon-warning"
        style="font-size: 48px; color: #e6a23c; margin-bottom: 16px"
      ></i>
      <p style="font-size: 16px; color: #606266; line-height: 1.6">
        结算单【{{ settlementBatchName }}:{{
          responsibleUserIdStr
        }}】当前状态不支持修改，如需修改需将结算单保存至【预结算】
      </p>
      <p style="font-size: 16px; color: #e6a23c; margin-top: 12px">
        是否确认保存至【预结算】？
      </p>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" size="small">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" size="small"
        >确 认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ConfirmEdit",
  data() {
    return {
      dialogVisible: false,
      currentRow: null,
      settlementBatchName: "",
      responsibleUserIdStr: "",
    };
  },
  methods: {
    // 打开确认弹窗
    open(row) {
      this.currentRow = row;
      this.settlementBatchName = row.settlementBatchName || "";
      this.responsibleUserIdStr = row.responsibleUserIdStr || "";
      this.dialogVisible = true;
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.currentRow = null;
      this.settlementBatchName = "";
      this.responsibleUserIdStr = "";
    },

    // 取消操作
    handleCancel() {
      this.handleClose();
    },

    // 确认操作
    handleConfirm() {
      const data = {
        id: this.currentRow.id,
        totalAmount: 0,
        status: this.currentRow.status, // 3:预结算
      };
      this.axios({
        url: `/v1/web/settlement-manage/settlement-order/updateToDraft/${this.currentRow.id}`,
        method: "post",
        data,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.$emit("confirm-edit");
            this.handleClose();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((error) => {
          this.$message.error("An error occurred: " + error.message);
        });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}

.el-icon-warning {
  display: block;
  margin: 0 auto;
}
</style>
